import { useTranslation } from "react-i18next";
import {
	type CourseLesson,
	getLessonDaysCount,
} from "src/components/Course/lessons/Lesson/RepetitionLesson";
import Progress from "src/components/ExamComponents/Progress";
import DefaultDetails, {
	DefaultScore,
} from "src/components/NewComponents/Views/Details/DefaultDetails";

interface ProgressDetailsProps {
	total: number;
}

const ProgressDetails = ({ total }: ProgressDetailsProps) => {
	const { t } = useTranslation();
	return (
		<Progress allItems={total} resolvedItems={0} unit={t("units.lessons")} />
	);
};

interface WaitingRepetitionDetailsProps {
	lesson: CourseLesson;
	className?: string;
}

export const WaitingRepetitionDetails = ({
	lesson,
	className,
}: WaitingRepetitionDetailsProps) => {
	const { t } = useTranslation();

	return (
		<DefaultDetails
			className={className}
			title={lesson.name}
			Progress={() => <ProgressDetails total={getLessonDaysCount(lesson)} />}
			Score={() => (
				<DefaultScore
					className="purple-box"
					title={t("course.lessons.revision")}
				/>
			)}
		/>
	);
};
